import { Button } from "reactstrap";
import classnames from "classnames";

export const SkinnedButton = (props: any) => {
  return <Button {...props} className={classnames(props.className)}></Button>;
};
